module.exports = __webpack_public_path__ + "img/dote.d8555039.svg";